exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-gallery[data-v-3b7d27f0] {\n  text-align: center;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  padding-top: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  min-height: auto;\n}\n.media-gallery--loaded[data-v-3b7d27f0] {\n    background-image: none;\n}\n", ""]);

// exports
